<div class="modal-header" style="border-bottom: 2px solid #00d398; padding: 1rem 1.5rem;">
  <div>
    <h4 class="modal-title" style="font-family: 'Rubik', serif; font-weight: 600; margin-bottom: 2px;">
      {{ getFirstSegment()?.departure?.airport }} / {{ getLastSegment()?.arrival?.airport }} ({{ getStopsLabel() }})
    </h4>
    <p style="margin-bottom: 0; font-size: 14px; color: #666; text-transform: capitalize;">
      {{ formatDate(getFirstSegment()?.departure?.date) }}
    </p>
  </div>
  <button type="button" class="btn-close close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>

<div class="modal-body" style="padding: 1.5rem; max-height: 75vh; overflow-y: auto;">

  <!-- TRAMO: resumen del tramo completo (todos los segmentos, con escalas) -->
  <div style="border: 1px solid #e9ecef; border-radius: 8px; overflow: hidden; margin-bottom: 1rem;">
    <div style="background-color: #e9ecef; padding: 8px 16px; font-size: 12px; font-weight: 700; letter-spacing: .5px; color: #555;">
      TRAMO
    </div>

    <div class="d-flex align-items-center justify-content-between flex-wrap" style="padding: 1.25rem; gap: 10px;">
      <div class="text-center">
        <h3 style="font-size: 22px; font-weight: 700; margin-bottom: 0; color: #333;">
          {{ formatTime(getFirstSegment()?.departure?.dateTime) }}
        </h3>
        <p style="margin-bottom: 0; font-size: 13px; color: #666;">{{ getFirstSegment()?.departure?.airport }}</p>
      </div>

      <ng-container *ngFor="let segment of getAllSegments(); let i = index; let last = last">
        <div class="text-center" style="flex: 0 0 auto;">
          <div class="d-flex align-items-center">
            <div style="width: 40px; height: 2px; background-color: #00d398;"></div>
            <i class="bi bi-airplane-fill" style="color: #00d398; font-size: 18px; margin: 0 4px;"></i>
            <div style="width: 40px; height: 2px; background-color: #00d398;"></div>
          </div>
          <p style="margin: 4px 0 0; font-size: 11px; color: #666;">
            {{ segment.cabin?.brandName || segment.cabin?.class }}<br/>
            {{ segment.airline?.code }} {{ segment.flight?.number }}<br/>
            {{ segment.flight?.equipment }}
          </p>
        </div>

        <div *ngIf="!last" class="text-center">
          <p style="margin-bottom: 2px; font-size: 12px; font-weight: 600; color: #333;">Escala</p>
          <p style="margin-bottom: 0; font-size: 11px; color: #666;">{{ formatDuration(calculateLayover(i)) }}</p>
          <p style="margin-bottom: 0; font-size: 12px; font-weight: 600; color: #333;">
            {{ segment.arrival?.time }} / {{ getAllSegments()[i+1]?.departure?.time }}
          </p>
          <p style="margin-bottom: 0; font-size: 11px; color: #666;">{{ segment.arrival?.airport }}</p>
        </div>
      </ng-container>

      <div class="text-center">
        <h3 style="font-size: 22px; font-weight: 700; margin-bottom: 0; color: #333;">
          {{ formatTime(getLastSegment()?.arrival?.dateTime) }}
        </h3>
        <p style="margin-bottom: 0; font-size: 13px; color: #666;">{{ getLastSegment()?.arrival?.airport }}</p>
      </div>
    </div>

    <!-- Navegación por tramo (sólo si hay escalas) -->
    <div *ngIf="getAllSegments().length > 1" style="border-top: 1px solid #e9ecef;">
      <div class="d-flex align-items-center justify-content-between" style="padding: 10px 16px;">
        <div class="d-flex align-items-center" style="gap: 18px; flex-wrap: wrap;">
          <ng-container *ngFor="let step of getTramoSteps()">
            <button
              *ngIf="step.type === 'tramo'"
              type="button"
              (click)="selectSegment(step.segmentIndex)"
              [style.color]="selectedSegmentIndex === step.segmentIndex ? '#000' : '#999'"
              [style.font-weight]="selectedSegmentIndex === step.segmentIndex ? '700' : '500'"
              style="background: none; border: none; font-size: 12px; letter-spacing: .5px; padding: 0;"
            >
              {{ step.label }}
            </button>
            <span *ngIf="step.type === 'escala'" style="font-size: 12px; color: #999;">{{ step.label }}</span>
          </ng-container>
        </div>
        <button
          type="button"
          *ngIf="hasNextSegment()"
          (click)="nextSegment()"
          style="background: none; border: none; color: #333; font-size: 16px;"
        >
          &rsaquo;
        </button>
      </div>
      <div style="height: 3px; background-color: #e9ecef;">
        <div
          [style.width]="((selectedSegmentIndex + 1) / getAllSegments().length * 100) + '%'"
          style="height: 100%; background-color: #000000; transition: width .2s ease;"
        ></div>
      </div>
    </div>
  </div>

  <!-- Información del tramo seleccionado -->
  <h5 style="font-weight: 600; margin-bottom: 1rem;">Información</h5>
  <div class="row" style="margin-bottom: 1.5rem;">
    <div class="col-6 mb-3">
      <p style="margin-bottom: 2px; font-size: 12px; color: #666;"><i class="bi bi-clock"></i> Desde</p>
      <p style="margin-bottom: 0; font-weight: 600;">{{ getSelectedSegment()?.departure?.airport }}</p>
    </div>
    <div class="col-6 mb-3">
      <p style="margin-bottom: 2px; font-size: 12px; color: #666;"><i class="bi bi-clock"></i> Hasta</p>
      <p style="margin-bottom: 0; font-weight: 600;">{{ getLastSegment()?.arrival?.airport }}</p>
    </div>
    <div class="col-6 mb-3">
      <p style="margin-bottom: 2px; font-size: 12px; color: #666;"><i class="bi bi-geo-alt"></i> Hora de Salida</p>
      <p style="margin-bottom: 0; font-weight: 600;">{{ formatTime(getSelectedSegment()?.departure?.dateTime) }}</p>
    </div>
    <div class="col-6 mb-3">
      <p style="margin-bottom: 2px; font-size: 12px; color: #666;"><i class="bi bi-geo-alt"></i> Hora de llegada</p>
      <p style="margin-bottom: 0; font-weight: 600;">{{ formatTime(getSelectedSegment()?.arrival?.dateTime) }}</p>
    </div>
    <div class="col-6 mb-3">
      <p style="margin-bottom: 2px; font-size: 12px; color: #666;"><i class="bi bi-clock-history"></i> Información de Viaje</p>
      <p style="margin-bottom: 0; font-weight: 600;">Tiempo de Vuelo: {{ formatDuration(getSelectedSegment()?.duration) }}</p>
    </div>
    <div class="col-6 mb-3">
      <p style="margin-bottom: 2px; font-size: 12px; color: #666;"><i class="bi bi-airplane"></i> Vuelo</p>
      <p style="margin-bottom: 0; font-weight: 600;">
        {{ getSelectedSegment()?.airline?.code }} {{ getSelectedSegment()?.flight?.number }}
        ({{ getSelectedSegment()?.flight?.equipment }})
      </p>
    </div>
  </div>

  <!-- <button
    type="button"
    class="btn d-flex align-items-center"
    style="gap: 8px; border: 1px solid #00d398; color: #00a67a; background: none; border-radius: 50rem; padding: 0.4rem 1.2rem; font-family: 'Rubik'; font-size: 13px; font-weight: 600; margin-bottom: 1.5rem;"
    (click)="openSeatMap()"
  >
    <i class="bi bi-grid-3x3"></i>
    Ver mapa de asientos
  </button> -->

  <!-- Familias tarifarias -->
  <h5 style="font-weight: 600; margin-bottom: 1rem;">Tarifas disponibles</h5>

  <div *ngIf="loadingFareOptions" class="text-center" style="padding: 2rem 0; color: #666;">
    Buscando tarifas disponibles...
  </div>

  <div *ngIf="!loadingFareOptions && fareOptionsError" class="text-center" style="padding: 1.5rem; background-color: #fff3e0; border-radius: 8px;">
    <p style="margin-bottom: 10px; font-size: 14px;">No pudimos traer las tarifas alternativas para este vuelo.</p>
    <button
      type="button"
      class="btn"
      [disabled]="processing"
      (click)="chooseFare(null)"
      style="background-color: #00d398; color: white; border-radius: 50rem; padding: 0.4rem 1.2rem;"
    >
      Continuar con la tarifa original
    </button>
  </div>

  <div *ngIf="!loadingFareOptions && !fareOptionsError" class="d-flex" style="gap: 12px; overflow-x: auto; padding-bottom: 8px;">
    <div
      *ngFor="let fare of fareOptions; let first = first"
      style="flex: 0 0 220px; border: 1px solid #e9ecef; border-radius: 10px; overflow: hidden; display: flex; flex-direction: column;"
    >
      <div
        [style.background-color]="first ? '#000000' : '#f1f1f1'"
        [style.color]="first ? '#ffffff' : '#000000'"
        style="padding: 10px 14px; font-weight: 700; font-size: 15px;"
      >
        {{ getFareLabel(fare) }}
      </div>

      <div style="padding: 14px; flex: 1;">
        <div *ngFor="let group of getFareFeatureGroups(fare)" style="margin-bottom: 12px;">
          <p style="margin-bottom: 4px; font-size: 12px; font-weight: 700; text-transform: uppercase; color: #333;">
            {{ group.title }}
          </p>
          <ul style="padding-left: 18px; margin-bottom: 0;">
            <li *ngFor="let line of group.lines" style="font-size: 12px; color: #555; margin-bottom: 4px;">
              {{ line }}
            </li>
          </ul>
        </div>
      </div>

      <div style="padding: 14px; border-top: 1px solid #e9ecef;">
        <p style="margin-bottom: 2px; font-size: 20px; font-weight: 700; color: #333;">
          {{ fare.price?.total | number: '1.2-2' }} {{ fare.price?.currency }}
        </p>
        <p style="margin-bottom: 10px; font-size: 11px; color: #999;">Por pasajero, incluye tasas e impuestos</p>

        <button
          type="button"
          class="btn w-100"
          [disabled]="processing"
          (click)="chooseFare(fare)"
          style="background-color: #00d398; color: white; border-radius: 50rem; padding: 0.5rem 0;"
        >
          {{ processing && isFareChosen(fare) ? 'Procesando...' : 'Elegir' }}
        </button>
      </div>
    </div>
  </div>
</div>
